module.exports = __webpack_public_path__ + "assets/img/title-f4015499.png";